<template>
  <div>
    <TopMenu :leftOption="'back-dashboard'" :title="$t('Playlist Schedule')"/>
    <div class="view">
      <transition name="fade" appear>
        <ScheduleLayout
          :schedules="schedules"
          :loading="loadingSchedules"
          :deletingSchedules="deletingSchedules"
          :editRoute="ROUTE_PLAYLIST_SCHEDULE_EDIT"
          :addRoute="ROUTE_PLAYLIST_SCHEDULE_ADD"
          :addButtonText="$t('Add Schedule')"
          @edit="editSchedule"
          @delete="deleteSchedule"
          @create="createSchedule"

        >
          <template #mobile-item="{ schedule }">
            <SongCover
              v-if="schedule.playlist"
              :coverUrl="schedule.playlist.cover_url"
              :alt="schedule.playlist.name"
              :size="40"
              class="mr-3"
            />
            <div>
              <span class="text-white h3 font-weight-light">{{schedule.start_time.substr(0,5)}}</span><br>
              <small class="text-muted">{{ schedule.playlist ? schedule.playlist.name : '(' + $t('Stop playback') + ')' }}</small>
            </div>
          </template>
          <template #desktop-item="{ schedule }">
            <SongCover
              v-if="schedule.playlist"
              :coverUrl="schedule.playlist.cover_url"
              :alt="schedule.playlist.name"
              :size="32"
              class="mr-2"
            />
            <div class="week-schedule-info">
              <span class="text-white font-weight-light">{{schedule.start_time.substr(0,5)}}</span><br>
              <small class="text-muted week-schedule-name">{{ schedule.playlist ? schedule.playlist.name : '(' + $t('Stop playback') + ')' }}</small>
            </div>
          </template>
        </ScheduleLayout>
      </transition>
    </div>
  </div>
</template>

<script>
import musicboxClient from '@/utils/musicboxClient'
import { ROUTE_PLAYLIST_SCHEDULE_ADD, ROUTE_PLAYLIST_SCHEDULE_EDIT } from '@/const/routeNames'
import SongCover from '@/components/shared/SongCover'
import ScheduleLayout from '@/components/shared/ScheduleLayout'

export default {

  name: 'PlaylistSchedule',

  components: {
    SongCover,
    ScheduleLayout
  },

  created () {
    this.loadingSchedules = true
    musicboxClient
      .getSchedules(this.$store.state.audio.currentBox.uuid)
      .then(res => {
        this.schedules = res.data != null ? res.data : []
      })
      .catch(e => {
        this.$notify.danger(this.$t('Failed to load schedules'))
      })
      .then(() => { this.loadingSchedules = false })
  },

  data () {
    return {
      ROUTE_PLAYLIST_SCHEDULE_ADD,
      ROUTE_PLAYLIST_SCHEDULE_EDIT,
      loadingSchedules: false,
      deletingSchedules: new Set(),
      schedules: []
    }
  },

  methods: {
    deleteSchedule (schedule) {
      if (this.deletingSchedules.has(schedule.id)) { return }
      this.deletingSchedules.add(schedule.id)
      this.deletingSchedules = new Set(this.deletingSchedules)
      musicboxClient
        .deleteSchedule(this.$store.state.audio.currentBox.uuid, schedule.id)
        .then(res => {
          this.$notify.success(this.$t('Schedule deleted'))
          this.schedules = this.schedules.filter(s => s.id !== schedule.id)
        })
        .catch(e => { this.$notify.danger(this.$t('Failed to delete schedule')) })
        .then(() => {
          this.deletingSchedules.delete(schedule.id)
          this.deletingSchedules = new Set(this.deletingSchedules)
        })
    },
    editSchedule (schedule) {
      this.$store.commit('clearEditedSchedule')
      this.$router.push(ROUTE_PLAYLIST_SCHEDULE_EDIT.replace(':id', schedule.id))
    },
    createSchedule (selectedDayOfWeek) {
      this.$store.commit('initEditedSchedule')
      const preselect = new Set()
      preselect.add(selectedDayOfWeek)
      this.$store.commit('updateEditedSchedule', { key: 'selectedDaysOfWeek', value: preselect })
      this.$router.push(ROUTE_PLAYLIST_SCHEDULE_ADD)
    },

  }
}

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/PlaylistSchedule.vue